import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function LangToggle({ lang, setLang }) {
  return (
    <div className="flex gap-2 mb-8">
      {['es', 'en'].map(l => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className="fhc-ui font-bold px-3 py-1 transition-all"
          style={{ color: lang === l ? 'var(--fhc-gold)' : 'var(--fhc-gray)', borderBottom: lang === l ? '2px solid var(--fhc-gold)' : '2px solid transparent' }}
          data-testid={`lang-${l}`}
        >{l.toUpperCase()}</button>
      ))}
    </div>
  );
}

function Article({ title, children }) {
  return (
    <article className="mb-14">
      <h3 className="text-[20px] md:text-[26px] leading-[1.4] mb-4" style={{ color: 'var(--fhc-navy)' }}>{title}</h3>
      <div className="fhc-body whitespace-pre-line" style={{ color: 'var(--fhc-navy)', lineHeight: 1.9 }}>{children}</div>
    </article>
  );
}

function EntityStatement() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-14 pb-10" style={{ borderBottom: '1px solid var(--fhc-stone)' }}>
      {[
        ['Entidad', 'Freedom Life Club LLC'],
        ['Jurisdicción', 'Wyoming, Estados Unidos de América'],
        ['Naturaleza', 'Plataforma educativa y comunidad privada de membresía'],
        ['Contacto', 'info@freedomhomes.club'],
      ].map(([label, value]) => (
        <React.Fragment key={label}>
          <div><p className="fhc-label">{label}</p></div>
          <div><p className="fhc-body" style={{ color: 'var(--fhc-navy)' }}>{value}</p></div>
        </React.Fragment>
      ))}
    </div>
  );
}

function LegalFooter() {
  return (
    <section style={{ background: 'var(--fhc-navy)', padding: '48px 0' }}>
      <div className="max-w-[720px] mx-auto px-5 md:px-20">
        <div className="flex flex-wrap gap-6 mb-6">
          <Link to="/terms-conditions" className="fhc-ui underline" style={{ color: 'var(--fhc-gold)' }}>Términos y Condiciones</Link>
          <Link to="/privacy-policy-fhc" className="fhc-ui underline" style={{ color: 'var(--fhc-gold)' }}>Política de Privacidad</Link>
        </div>
        <p className="fhc-legal-text">Freedom Homes Club — Legal System v1.0 — 2026</p>
        <p className="fhc-legal-text mt-1">Freedom Life Club LLC | Wyoming, USA | info@freedomhomes.club</p>
      </div>
    </section>
  );
}

export { LangToggle, Article, EntityStatement, LegalFooter };
